import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {ViewCategoryTitle, ViewCategoryExplanation, ViewCategoryRgb, 
    ViewCategoryFontRgb, ViewCategoryImage} from "../Elements/AscElements/CategoryElements";

export default class CategoryReadModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.CategoryInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <ViewCategoryTitle
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewCategoryTitle>
                        <ViewCategoryExplanation
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewCategoryExplanation>
                        <ViewCategoryRgb
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewCategoryRgb>
                        <ViewCategoryFontRgb
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewCategoryFontRgb>
                        <ViewCategoryImage
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewCategoryImage>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

CategoryReadModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
